import { combineReducers } from "redux";
import thunk from "redux-thunk";
import { loadingBarReducer, loadingBarMiddleware } from "react-redux-loading-bar";
import { slices } from "@/constants/sliceNames";
import { configureStore } from "@reduxjs/toolkit";
import { getSocketMiddlewars } from "@/socket/appSockets";

import antSettingsReducer from "./reducers/SettingsReducer";
import { alertReducer } from "./reducers/AjaxHandler-reducer";
import { socketReducer } from "./reducers/socket-reducer";
import { lastActionReducer } from "./reducers/lastAction-reducer";
// import { requestUserInfo } from "./effects/auth-effects";
import WebRTCSliceReducer from "./slices/webrtc-slice";
import { loadPersistState, savePersistState } from "./persist";
import authSliceReducer from "./slices/auth-slice";
import DatasetsSliceReducer from "./slices/datasets-slice";
import InvitationsSliceReducer from "./slices/settings/invitations-slice";
import OrganizationsSliceReducer from "./slices/admin-dashboard/organizations-slice";
import AlertsSliceReducer from "./slices/admin-dashboard/alerts-slice";
import ResourcesSliceReducer from "./slices/admin-dashboard/resources-slice";
import RolesSliceReducer from "./slices/admin-dashboard/roles-slice";
import UsersSliceReducer from "./slices/admin-dashboard/users-slice";
import ExecutionsSliceReducer from "./slices/executions/executions-slice";
import cameraSliceReducer from "./slices/camera/camera-slice";
import datasourceSliceReducer from "./slices/data-source/data-source-slice";
import modelDeploymentSliceReducer from "./slices/modelDeployment-slice";
import batchPredictionMonitoringSliceReducer from "./slices/batchPredictionMonitoring-slice";
import runExecutionSliceReducer from "./slices/run-execution/runExecution-slice";
import recurrentBatchSliceReducer from "./slices/recurrentBatch-slice";
import predictionSliceReducer from "./slices/prediction-slice";
import datasetAnalysisSliceReducer from "./slices/datasetAnalysis-slice";
import assetsSliceReducer from "./slices/assets-slice";
import downloadSliceReducer from "./slices/download-slice";
import applicationsSliceReducer from "./slices/applications-slice";
import monitoringAlertsSliceReducer from "./slices/monitoring/monitoringAlerts-slice";
import connectorsSliceReducer from "./slices/connectors-slice";
import authorizationSliceReducer from "./slices/authorization-slice";
import cameraGroupReducer from "./slices/camera/cameraGroup-slice";
import { requestUserPermissions } from "./effects/authorization-effects";
import { requestUserInfo } from "./effects/auth-effects";

const rootReducer = combineReducers({
  loadingBar: loadingBarReducer,
  [slices.auth]: authSliceReducer,
  antSettings: antSettingsReducer,
  [slices.datasets]: DatasetsSliceReducer,
  [slices.assets]: assetsSliceReducer,
  alert: alertReducer,
  [slices.executions]: ExecutionsSliceReducer,
  [slices.prediction]: predictionSliceReducer,
  socket: socketReducer,
  [slices.webrtc]: WebRTCSliceReducer,
  lastAction: lastActionReducer,
  [slices.download]: downloadSliceReducer,
  [slices.applications]: applicationsSliceReducer,
  [slices.runExecution]: runExecutionSliceReducer,
  [slices.datasetAnalysis]: datasetAnalysisSliceReducer,
  [slices.connectors]: connectorsSliceReducer,
  [slices.recurrentBatch]: recurrentBatchSliceReducer,
  [slices.organizations]: OrganizationsSliceReducer,
  [slices.users]: UsersSliceReducer,
  [slices.roles]: RolesSliceReducer,
  [slices.invitations]: InvitationsSliceReducer,
  [slices.batchPredictionMonitoring]: batchPredictionMonitoringSliceReducer,
  [slices.authorization]: authorizationSliceReducer,
  [slices.monitoringAlerts]: monitoringAlertsSliceReducer,
  [slices.resources]: ResourcesSliceReducer,
  [slices.modelDeployment]: modelDeploymentSliceReducer,
  [slices.camera]: cameraSliceReducer,
  [slices.datasource]: datasourceSliceReducer,
  [slices.cameraGroups]: cameraGroupReducer,
  [slices.alerts]: AlertsSliceReducer,
});

// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// websockets middleware
const websocketMiddlewars = getSocketMiddlewars();

// load some state from localstorge if exist
const persistState = loadPersistState();

const store = configureStore({
  reducer: rootReducer,
  preloadedState: persistState,
  middleware: [
    thunk,
    ...websocketMiddlewars,
    loadingBarMiddleware({
      promiseTypeSuffixes: ["START", "SUCCESS", "FAIL"],
    }),
  ],
  devTools: process.env.NODE_ENV !== "production",
});

// check if user already logged in
if (persistState[slices.auth].userToken) {
  store.dispatch(requestUserInfo());
  store.dispatch(requestUserPermissions());
}

store.subscribe(() => {
  savePersistState(store.getState());
});

export default store;
